// Single source for the side navigation, page titles, and breadcrumbs.
// Groups are titled for the task they contain, per the EPLP left-nav pattern.
export const APP_NAME = "Claude Logs";
export const DEFAULT_VIEW = "activity";

export const NAV = [
  {
    group: "Audit",
    items: [
      { id: "activity", label: "Activity feed", icon: "clock" },
      { id: "prompts", label: "Code & Cowork", icon: "code" },
      { id: "chats", label: "Chat viewer", icon: "chat" },
    ],
  },
  {
    group: "Usage",
    items: [{ id: "analytics", label: "Analytics", icon: "chart" }],
  },
];

export function findView(id) {
  for (const { group, items } of NAV) {
    const item = items.find(i => i.id === id);
    if (item) return { ...item, group };
  }
  return null;
}
